<div *ngIf="model" class="dx-fieldset">


  <div class="dx-field">
    <div (mouseenter)="ttt(10)" (mouseleave)="ttt(10)" class="dx-field-label dx-field-label200">{{ 'Shop URL' | translate }}</div>
    <div class="dx-field-value {{showPlaceHolders ? 'inputWithPlaceHolder' : 'inputWithOutPlaceHolder' }}" id="tt10">
      <label class="placeLabel {{ model.baseUri?.length>0 ? 'placeLabelSmall' : '' }}">SHOP_URL</label>
      <dx-text-box (onValueChanged)="catalogChangedinclShop($event)" [(value)]="model.baseUri" [readOnly]="readOnlyUser('shopware6Url')" [showClearButton]="true">
      </dx-text-box>

    </div>
    <dx-tooltip [(visible)]="v[10]" class="toolTip toolTipField" target="#tt10">
      <div *dxTemplate="let data = data of 'content'">
        {{ 'Die Internetadresse des Shopware Shops' | translate }}.
      </div>
    </dx-tooltip>
  </div>

  <div class="dx-field">
    <div (mouseenter)="ttt(11)" (mouseleave)="ttt(11)" class="dx-field-label dx-field-label200">{{ 'Client Id' | translate }}</div>
    <div class="dx-field-value {{showPlaceHolders ? 'inputWithPlaceHolder' : 'inputWithOutPlaceHolder' }}" id="tt11">
      <label class="placeLabel {{ model.clientId?.length>0 ? 'placeLabelSmall' : '' }}">CLIENT_ID</label>
      <dx-text-box (onValueChanged)="catalogChangedinclShop($event)" [(value)]="model.clientId" [readOnly]="readOnlyUser('shopware6ClientId')" [showClearButton]="true">
      </dx-text-box>

    </div>
    <dx-tooltip [(visible)]="v[11]" class="toolTip toolTipField" target="#tt11">
      <div *dxTemplate="let data = data of 'content'">
        {{ 'Die Client Id mit der die nextPIM sich beim Shop anmeldet.' | translate }}
      </div>
    </dx-tooltip>
  </div>

  <div class="dx-field">
    <div (mouseenter)="ttt(12)" (mouseleave)="ttt(12)" class="dx-field-label dx-field-label200">{{ 'Client Secret' | translate }}</div>
    <div class="dx-field-value {{showPlaceHolders ? 'inputWithPlaceHolder' : 'inputWithOutPlaceHolder' }}" id="tt12">
      <label class="placeLabel {{ model.clientSecret?.length>0 ? 'placeLabelSmall' : '' }}">CLIENT_SECRET</label>
      <dx-text-box (onValueChanged)="catalogChangedinclShop($event)" [(value)]="model.clientSecret" [readOnly]="readOnlyUser('shopware6ClientSecret')" [showClearButton]="true">
      </dx-text-box>

    </div>
    <dx-tooltip [(visible)]="v[11]" class="toolTip toolTipField" target="#tt11">
      <div *dxTemplate="let data = data of 'content'">
        {{ 'Das Passwort mit dem sich nextPIM beim Shop anmeldet' | translate }}
      </div>
    </dx-tooltip>
  </div>

  <div class="dx-field">
    <div (mouseenter)="ttt('lastSend')" (mouseleave)="ttt('lastSend')" class="dx-field-label">{{ 'Letzte Übertragung' | translate }}</div>
    <div class="dx-field-value {{showPlaceHolders ? 'inputWithPlaceHolder' : 'inputWithOutPlaceHolder' }}" id="ttlastSend">
      <label class="placeLabel {{ lastSend.length>0 ? 'placeLabelSmall' : '' }}">LAST_SEND</label>
      <dx-text-box [disabled]="true" [showClearButton]="false" [value]="lastSend">
      </dx-text-box>

    </div>
    <dx-tooltip [(visible)]="v['productRange']" class="toolTip toolTipField" target="#ttlastSend">
      <div *dxTemplate="let data = data of 'content'">
        {{ 'Datum der letzten Übertragung zu oder vom Shop' | translate }}.
      </div>
    </dx-tooltip>
  </div>

  <dx-toolbar>
    <dxi-item *ngIf="!modelService.catalogService.connection2Shop" [options]="{ stylingMode: 'outlined', type: 'default', text:  'Verbindung testen' | translate , onClick: testShopConnection }" location="before" widget="dxButton"></dxi-item>
    <dxi-item *ngIf="modelService.catalogService.connection2Shop" [options]="{ stylingMode: 'outlined', type: 'default', icon:'check',   text:  'Verbindung testen' | translate , onClick: testShopConnection }" location="before" widget="dxButton"></dxi-item>
    <dxi-item *ngIf="modelService.catalogService.connection2Shop && !readOnlyUser('shopware6SendCatalog')" [options]="{ stylingMode: 'outlined', type: 'default', text:  'Katalog senden' | translate , onClick: sendData2Shop }" location="before" widget="dxButton"></dxi-item>
    <dxi-item *ngIf="modelService.catalogService.connection2Shop && !readOnlyUser('shopware6SendCatalog')" [template]="'dateBoxTemplate'" location="after"></dxi-item>
    <div *dxTemplate="let data of 'dateBoxTemplate'">
      <dx-date-box [(value)]="scheduledFor" label="{{ 'Übertragung Startzeit' | translate}}" type="datetime" width="auto"></dx-date-box>
    </div>
  </dx-toolbar>

  <div style="color: red;">
    {{modelService.catalogService.connection2ShopMessage}}
  </div>

  <dx-tab-panel [dataSource]="pages"
                [selectedIndex]="0"
                style="margin-top: 5px;">
    <div *dxTemplate="let company of 'depictionTemplate'" style="margin-top: 20px;">
      <div class="dx-field">
        <div (mouseenter)="ttt(14)" (mouseleave)="ttt(14)" class="dx-field-label dx-field-label200">{{ 'Produkt Kategorie' | translate }}</div>
        <div class="dx-field-value" id="tt12">
          <dx-drop-down-box (onValueChanged)="syncTreeViewSelection()"
                            [(value)]="model.rootCatCategoryId"
                            [dataSource]="shopCategories"
                            [readOnly]="readOnlyUser('shopware6Categorie')"
                            [showClearButton]="true"
                            displayExpr="text"
                            placeholder="{{ 'Kategorie auswählen' | translate }}"
                            valueExpr="id">

            <div *dxTemplate="let data of 'content'">
              <dx-tree-view (onItemSelectionChanged)="treeView_itemSelectionChanged($event)"
                            [items]="shopCategories"
                            [selectByClick]="true"
                            dataStructure="plain"
                            displayExpr="text"
                            keyExpr="id"
                            parentIdExpr="parent"
                            selectionMode="single">
                <dxo-scrolling [useNative]="true">
                </dxo-scrolling>
              </dx-tree-view>
            </div>
          </dx-drop-down-box>



        </div>
        <dx-tooltip [(visible)]="v[11]" class="toolTip toolTipField" target="#tt11">
          <div *dxTemplate="let data = data of 'content'">
            {{ 'Die Kategorie in der sich die Produkte befinden' | translate }}
          </div>
        </dx-tooltip>
      </div>
      <div class="dx-field">
        <div (mouseenter)="ttt(14)" (mouseleave)="ttt(14)" class="dx-field-label dx-field-label200">{{ 'Kategorie Layout' | translate }}</div>
        <div class="dx-field-value" id="tt123">
          <dx-select-box (onValueChanged)="catalogChangedinclShop($event)"
                         [(value)]="model.categoryLayoutId"
                         [dataSource]="shopwareCmsPage"
                         [readOnly]="readOnlyUser('shopware6CategorieLayout')"
                         [showClearButton]="true"
                         displayExpr="name"
                         valueExpr="id"
                         [searchEnabled]="true">
            <dx-validator validationGroup="shopware6LayoutValidationGroup">
              <dxi-validation-rule message="{{ 'NoCategoryLayoutInfo' | translate }}"
                                   type="required">
              </dxi-validation-rule>
            </dx-validator>
          </dx-select-box>
        </div>
        <dx-tooltip [(visible)]="v[123]" class="toolTip toolTipField" target="#tt123">
          <div *dxTemplate="let data = data of 'content'">
            {{ 'Die Id des Shopware Kategorie Layouts' | translate }}
          </div>
        </dx-tooltip>
      </div>

      <div class="dx-field">
        <div (mouseenter)="ttt(14)" (mouseleave)="ttt(14)" class="dx-field-label dx-field-label200">{{ 'Produkt Layout' | translate }}</div>
        <div class="dx-field-value" id="tt123">
          <dx-select-box (onValueChanged)="catalogChangedinclShop($event)"
                         [(value)]="model.productLayoutId"
                         [dataSource]="shopwareCmsPage"
                         [readOnly]="readOnlyUser('shopware6CategorieLayout')"
                         [showClearButton]="true"
                         displayExpr="name"
                         valueExpr="id"
                         [searchEnabled]="true">
            <dx-validator validationGroup="shopware6LayoutValidationGroup">
              <dxi-validation-rule message="{{ 'NoProductLayoutInfo' | translate }}"
                                   type="required">
              </dxi-validation-rule>
            </dx-validator>
          </dx-select-box>
        </div>
        <dx-tooltip [(visible)]="v[123]" class="toolTip toolTipField" target="#tt123">
          <div *dxTemplate="let data = data of 'content'">
            {{ 'Die Id des Shopware Produkt Layouts' | translate }}
          </div>
        </dx-tooltip>
      </div>



      <div class="dx-field">
        <div (mouseenter)="ttt(14)" (mouseleave)="ttt(14)" class="dx-field-label dx-field-label200">{{ 'Standard Verkaufskanal für Produkte' | translate }}</div>
        <div class="dx-field-value" id="tt124">
          <dx-tag-box (onValueChanged)="catalogChangedinclShop($event)"
                      [(value)]="model.productChannelIds"
                      [items]="salesChannel"
                      [readOnly]="readOnlyUser('shopware6ProductChannel')"
                      displayExpr="name"
                      valueExpr="id">
          </dx-tag-box>
        </div>
        <dx-tooltip [(visible)]="v[124]" class="toolTip toolTipField" target="#tt124">
          <div *dxTemplate="let data = data of 'content'">
            {{ 'Der Verkaufskanal der den Produkten zugewiesen werden soll, wenn diese nicht in den Kategorien gefüllt wurde' | translate }}
          </div>
        </dx-tooltip>
      </div>


      <div class="dx-field">
        <div (mouseenter)="ttt(125)" (mouseleave)="ttt(125)" class="dx-field-label dx-field-label200">{{ 'Variantendarstellung in Kategorien' | translate }}</div>
        <div class="dx-field-value" id="tt125">

          <dx-select-box (onValueChanged)="catalogChangedinclShop($event)"
                         [(value)]="model.variantRepresentation"
                         [dataSource]="variantRepresentations"
                         [readOnly]="readOnlyUser('shopware6Variants')"
                         displayExpr="value"
                         valueExpr="key">
          </dx-select-box>

        </div>
        <dx-tooltip [(visible)]="v[125]" class="toolTip toolTipField" target="#tt125">
          <div *dxTemplate="let data = data of 'content'">
            {{ 'Sollen Varianten im Shop in Listen dargestellt werden, oder nur der Master Artikel' | translate }}
          </div>
        </dx-tooltip>
      </div>

      <div class="dx-field">
        <div class="dx-field-label">{{ 'Kategorie-Layouts überschreiben' | translate }}</div>
        <div class="dx-field-value">
          <dx-switch (onValueChanged)="catalogChangedinclShop($event)" [(value)]="model.overwriteCategoryLayouts" [readOnly]="readOnlyUser('shopware6OverwriteCategoryLayouts')"></dx-switch>
        </div>
      </div>
    </div>
    <div *dxTemplate="let company of 'priceTemplate'" style="margin-top: 20px;">
      <div class="dx-field">
        <div class="dx-field-label">{{ 'Datumsregeln für Preise aktivieren' | translate }}</div>
        <div class="dx-field-value">
          <dx-switch (onValueChanged)="catalogChanged($event)" [(value)]="model.enableDateRules" [readOnly]="readOnlyUser('shopware6EnableDateRules')"></dx-switch>
        </div>
      </div>
      <div *ngIf="model.enableDateRules" class="dx-field">
        <div class="dx-field-label">{{ 'Datumsregeln nur bei mehreren Zeiträumen anwenden' | translate }}</div>
        <div class="dx-field-value">
          <dx-switch (onValueChanged)="catalogChanged($event)" [(value)]="model.dateRulesOnlyForMultiplePeriods" [readOnly]="readOnlyUser('shopware6DateRulesOnlyForMultiplePeriods')"></dx-switch>
        </div>
      </div>
      <div class="dx-field">
        <div class="dx-field-label">{{ 'Preise nur bei Neuanlage übertragen' | translate }}</div>
        <div class="dx-field-value">
          <dx-switch (onValueChanged)="catalogChanged($event)" [(value)]="model.dontUpdatePrices" [readOnly]="readOnlyUser('shopware6DontUpdatePrices')"></dx-switch>
        </div>
      </div>
      <dx-data-grid [dataSource]="salesChannelToPriceLists"
                    [editing]="{ mode: 'cell', allowUpdating: true }"
                    [rowAlternationEnabled]="true"
                    [showBorders]="true">
        <dxi-column [allowEditing]="false"
                    caption="{{ 'Verkaufskanäle' | translate }}"
                    cellTemplate="test"
                    dataField="salesChannel">
          <div *dxTemplate="let rowData of 'test'">
            {{ rowData?.data?.salesChannel?.name }}
          </div>
        </dxi-column>


        <dxi-column [showEditorAlways]="true"
                    caption="{{ 'Preislisten' | translate }}"
                    dataField="priceList"
                    editCellTemplate="priceListDropDownTemplate" />
        <div *dxTemplate="let priceList of 'priceListDropDownTemplate'">
          <dx-select-box (onValueChanged)="updateSalesChannelsToPriceList($event, priceList.data)"
                         [(value)]="priceList.data.priceListOrder"
                         [dataSource]="modelService.catalogService.catalog.priceLists"
                         [displayExpr]="displayExprPricelist"
                         [showClearButton]="true"
                         valueExpr="order" />
        </div>
      </dx-data-grid>
    </div>
    <div *dxTemplate="let company of 'additionalTemplate'" style="margin-top: 20px;">
      <div class="dx-field">
        <div (mouseenter)="ttt(1254)" (mouseleave)="ttt(1254)" class="dx-field-label dx-field-label200">{{ 'Sprachen für die Übertragung' | translate }}</div>
        <div class="dx-field-value" id="tt1254">

          <dx-tag-box (onValueChanged)="catalogChanged($event)"
                      [(value)]="model.languages"
                      [acceptCustomValue]="false"
                      [dataSource]="languages"
                      [readOnly]="readOnlyUser('shopware6Language')"
                      [showSelectionControls]="true"
                      displayExpr="name"
                      placeholder=""
                      valueExpr="id">
          </dx-tag-box>

        </div>
        <dx-tooltip [(visible)]="v[1254]" class="toolTip toolTipField" target="#tt1254">
          <div *dxTemplate="let data = data of 'content'">
            {{ 'Welche Sprachen sollen zum Shop übertragen werden' | translate }}
          </div>
        </dx-tooltip>
      </div>

      <div class="dx-field">
        <div class="dx-field-label dx-field-label200">{{ 'Zusätzliche Merkmalsgruppe' | translate }}</div>
        <div class="dx-field-value">
          <dx-tag-box (onValueChanged)="catalogChanged($event)"
                      [(value)]="model.additionalFeatureSystemNames"
                      [dataSource]="featureSystemNames"
                      [readOnly]="readOnlyUser('shopware6AdditionalFeatureSystemNames')">
          </dx-tag-box>
        </div>
      </div>

      <div class="dx-field">
        <div class="dx-field-label">{{ 'Gefahrstoffklassen an Beschreibung anhängen' | translate }}</div>
        <div class="dx-field-value">
          <dx-switch (onValueChanged)="catalogChangedinclShop($event)" [(value)]="model.includeHazmatClassesInDescription" [readOnly]="readOnlyUser('shopware6WarningsAppend')"></dx-switch>
        </div>
      </div>
      <div class="dx-field">
        <div class="dx-field-label">{{ 'Alle Produkte ohne Kategorie in Shopware deaktivieren' | translate }}</div>
        <div class="dx-field-value">
          <dx-switch (onValueChanged)="catalogChangedinclShop($event)" [(value)]="model.deactivateProductsWithoutCategory" [readOnly]="readOnlyUser('shopware6DeactivateProductsWithoutCategory')"></dx-switch>
        </div>
      </div>

      <div *ngIf="modelService.loginService.hasAddonSHOPWARE6_ASYNCINDEXING" class="dx-field" npTooltip
           npTooltipTextId="Queue-Indexing Warning">
        <div npTooltipTrigger class="dx-field-label">{{ 'Queue-Indexing nutzen' | translate }}</div>
        <div class="dx-field-value">
          <dx-switch (onValueChanged)="catalogChanged($event)" [(value)]="model.useQueueIndexing"
                     npTooltipTarget></dx-switch>
        </div>
      </div>

        <div *ngIf="modelService.loginService.hasAddonDataSources" class="dx-field" npTooltip
           npTooltipTextId="Brand as Manufacturer Hint">
        <div npTooltipTrigger class="dx-field-label">{{ 'Hersteller durch Markeninformationen ersetzen' | translate }}
        </div>
        <div class="dx-field-value">
          <dx-switch (onValueChanged)="catalogChanged($event)" [(value)]="model.exportBrandAsManufacturer"
                     npTooltipTarget></dx-switch>
        </div>
      </div>

        <div *ngIf="modelService.loginService.hasAddonDataSources" class="dx-field" npTooltip
           npTooltipTextId="Brand as Feature Hint">
        <div npTooltipTrigger class="dx-field-label">{{ 'Marke als Eigenschaft übergeben' | translate }}</div>
        <div class="dx-field-value">
          <dx-switch (onValueChanged)="catalogChanged($event)" [(value)]="model.exportBrandAsTechnicalFeature"
                     npTooltipTarget></dx-switch>
        </div>
      </div>

      <div></div>
      <!--- Dieses dummy div wird benötigt damit der tooltip "Brand as Feature Hint" korrekt positioniert ist !-->
    </div>
  </dx-tab-panel>
</div>
